module.exports = __webpack_public_path__ + "static/media/pic-history1.95cf1a72.webp";